import { render, staticRenderFns } from "./RyuryoChart.vue?vue&type=template&id=f6a6e4fe&scoped=true"
import script from "./RyuryoChart.vue?vue&type=script&lang=ts"
export * from "./RyuryoChart.vue?vue&type=script&lang=ts"
import style0 from "./RyuryoChart.vue?vue&type=style&index=0&id=f6a6e4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a6e4fe",
  null
  
)

export default component.exports